import enviro from 'enviro';
import { ENTERPRISE, STARTER } from '../v2/constants/Tabs';
export function generateUuid() {
  try {
    const chars = '0123456789abcdef'.split('');
    const uuid = [];
    for (let i = 0; i < 16; i++) {
      uuid.push(chars[Math.floor(Math.random() * chars.length)]);
    }
    return uuid.join('');
  } catch (e) {
    return null;
  }
}
export function readCookie(name) {
  const nameEQ = `${name}=`;
  const ca = document.cookie.split(';');
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) === ' ') c = c.substring(1, c.length);
    if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
  }
  return null;
}
export function getUtk() {
  try {
    const hstcCookie = readCookie('__hstc') || '';
    const utk = hstcCookie.split('.')[1];
    return utk;
  } catch (e) {
    return null;
  }
}
export function getLocalStorageItem(key) {
  try {
    return localStorage.getItem(key);
  } catch (err) {
    return null;
  }
}
export function getBooleanFromString(string) {
  return string === 'true';
}
export function getQueryParam(string) {
  try {
    const urlParams = new URLSearchParams(window.location.search);
    return urlParams.get(string);
  } catch (err) {
    return null;
  }
}
export function getStashedUuid() {
  try {
    return getQueryParam('luid') || readCookie('luid') || null;
  } catch (e) {
    return null;
  }
}
export function getShortLinkForRedirect(url) {
  const {
    hostname,
    pathname,
    search
  } = new URL(url);
  const IS_QA = hostname.includes('hubspotqa') || hostname.includes('wthubspot');
  const APP_DOMAIN = enviro.ifHublet({
    isNa1() {
      return `app.hubspot${IS_QA ? 'qa' : ''}.com`;
    },
    isNonNa1(hublet) {
      return `app-${hublet}.hubspot${IS_QA ? 'qa' : ''}.com`;
    }
  });

  // get path after /pricing
  const newPath = pathname.split('/').slice(2).filter(path => path !== STARTER && path !== ENTERPRISE).join('/');

  /**
   * Most query params are NOT preserved through short links.
   * Should be fine as most people are just going to the base /pricing/X pages
   * If we want to preserve query params we'll need to explicitly whitelist the query params, which can be done in this config:
   * https://private.hubteam.com/config/com.hubspot.shortlinks.service/ShortlinksConfig/ALLOWED_QUERY_PARAMS/STRING_SET
   * ShortLinks docs: https://product.hubteam.com/docs/product-platform/shortlinks.html
   */
  return `https://${APP_DOMAIN}/l/pricing/${newPath}${search}`;
}